import React from "react";
import { withRouter } from "react-router-dom";

import MainButton from "../main-button";
import InsuredCard from "../insured-card/insured-card";
import { images } from "../../assets";
import { TravelHireMenuContainer } from "./travel-hire-menu-style";

import { withPolicy } from "../../context/mixin/with-policy";
import { TravelHireMenuHelper } from "./travel-hire-menu-helpers";
import { StepsTravel, TravelHireMenuProps, TravelHireMenuState } from "./travel-hire-menu-types";

class TravelHireMenuLayout extends React.Component<TravelHireMenuProps, TravelHireMenuState> {
  constructor(props: TravelHireMenuProps) {
    super(props);

    this.state = {
      currentStep: props.initialCurrentStep,
      insureds: props.initialInsureds,
      showInsuredsOnDatosAsegurados: props.initialCurrentStep === StepsTravel.DatosAsegurados,
    };
  }

  componentDidMount() {
    this.props.history.listen((location) => {
      var step = TravelHireMenuHelper.getStepFromNavigationRoute(
        location.pathname,
        this.props.policyType
      );
      this.setState({
        currentStep: step,
        showInsuredsOnDatosAsegurados: step === StepsTravel.DatosAsegurados,
      });
    });
  }

  componentWillReceiveProps(nextProps: TravelHireMenuProps) {
    if (nextProps.initialInsureds !== this.props.initialInsureds) {
      this.setState({ insureds: nextProps.initialInsureds });
    }
  }

  getButtonCssName = (step: StepsTravel): string =>
    step === this.state.currentStep ? "" : "google";

  isMenuItemDisabled = (step: StepsTravel): boolean => step > this.state.currentStep;

  isMenuItemSelected = (step: StepsTravel): boolean => step === this.state.currentStep;

  handleNavigation(step: StepsTravel): void {
    if (step === this.state.currentStep) return;

    const isDatosAsegurados = step === StepsTravel.DatosAsegurados;
    this.setState({ showInsuredsOnDatosAsegurados: isDatosAsegurados });

    if (!isDatosAsegurados) {
      this.props.history.push(
        TravelHireMenuHelper.getStepNavigationPath(
          step,
          this.state.insureds.length,
          this.props.policyType
        )
      );
    }
  }

  tryDownloadPrecontractualDocument(): void {
    if (this.props.downloadDocs) this.props.downloadDocs();
  }

  tyrSendMailPrecontractualDocument() {
    if (this.props.sendMailPrecontractualDocument) this.props.sendMailPrecontractualDocument();
  }

  tryResumeOnHiring(): void {
    if (this.props.resumeOnHiring) this.props.resumeOnHiring();
  }

  async tryInsuredOnAdd(): Promise<void> {
    if (this.props.insuredOnAdd) {
      await this.props.insuredOnAdd(this.props.insuredSaved);
    }
  }

  tryInsuredOnSave(): void {
    if (this.props.insuredOnSave) {
      this.props.insuredOnSave();
    }
  }

  isSubMenuItemSelected = (step: StepsTravel, numInsured: number): boolean =>
    step === this.state.currentStep &&
    numInsured === (this.props.currentNumInsured ? this.props.currentNumInsured : 0);

  tryRemoveInsured(event: React.MouseEvent<HTMLDivElement, MouseEvent>, step: StepsTravel, numInsured: number): void {
    event.stopPropagation();

    if (step === StepsTravel.DatosAsegurados && this.props.insuredOnRemove) {
      this.props.insuredOnRemove(numInsured);
    }
  }

  tryGoToDetail(step: StepsTravel, numInsured: number): void {
    if (step === StepsTravel.DatosAsegurados && this.props.insuredOnEdit) {
      this.props.insuredOnEdit(numInsured);
    }
  }

  renderInsuredCards(
    renderForStep: StepsTravel,
    showRemoveIco: boolean = true,
    divClickGoToDetail: boolean = false
  ): JSX.Element[] {
    let elements: JSX.Element[] = [];
    if (this.state.insureds) {
      for (let i = 0; i < this.state.insureds.length; i++) {
        elements.push(
          <li key={`asegurado-${i}`}>
            <InsuredCard
              selected={this.isSubMenuItemSelected(renderForStep, i)}
              insuredMember={this.state.insureds[i]}
              removeInsured={
                !this.props.disableSubButtons && showRemoveIco
                  ? (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => this.tryRemoveInsured(event, renderForStep, i)
                  : undefined
              }
              goToDetail={() => this.tryGoToDetail(renderForStep, i)}
              textSubtitle={"Asegurado"}
              divClickGoToDetail={divClickGoToDetail}
            />
          </li>
        );
      }
    }
    return elements;
  }

  getMainButtonMenu(title: string, step: StepsTravel): JSX.Element {
    return (
      <MainButton
        text={title}
        type={this.getButtonCssName(step)}
        withTab={true}
        disabled={this.isMenuItemDisabled(step)}
        onClick={() => this.handleNavigation(step)}
      />
    );
  }

  getMainButtonSubMenu(
    title: string,
    step: StepsTravel,
    onClick: Function,
    type: string | undefined = "full-light",
    image?: string | undefined,
    disabled: boolean | undefined = undefined
  ): JSX.Element {
    return (
      <MainButton
        text={title}
        icon={image !== undefined}
        iconImg={image}
        type={type}
        withTab={true}
        disabled={disabled !== undefined ? disabled : this.isMenuItemDisabled(step)}
        onClick={() => onClick()}
      />
    );
  }

  render() {
    const { policy } = this.props;
    const productName = policy.product.products_name;
    const productCardName = policy.product.products_cardName;

    return (
      <TravelHireMenuContainer>
        <div className="inflow-sidebar-type">
          <img src={images.MiniWavePolicieTravel} alt="" />
          <div className="inflow-sidebar-type-wrapper">
            <div className="inflow-sidebar-type-text">
              <p>PÓLIZA {productCardName}</p>
            </div>
            <div className="inflow-sidebar-type-title">
              <p>{productName}</p>
            </div>
          </div>
        </div>
        <div className="cod-mediador">
          CÓD. MEDIADOR
          <br />
          <span>{this.props.selectedMediator || this.props.codMediador}</span>
        </div>
        <ul className="ulMenu">
          <div>
            <li>{this.getMainButtonMenu("DATOS DEL TOMADOR", StepsTravel.DatosTomador)}</li>
            <li>
              {this.getMainButtonMenu("DATOS DE LOS ASEGURADOS", StepsTravel.DatosAsegurados)}
              <ul
                className="ulSubmenu"
                style={{ display: this.state.showInsuredsOnDatosAsegurados ? "block" : "none" }}
              >
                {!this.props.disableSubButtons &&
                  this.state.currentStep === StepsTravel.DatosAsegurados && (
                    <li>
                      {this.getMainButtonSubMenu(
                        "GUARDAR ASEGURADO",
                        StepsTravel.DatosAsegurados,
                        () => this.tryInsuredOnSave(),
                        "full-light",
                        images.IconSaveWhite
                      )}
                    </li>
                  )}
                {this.renderInsuredCards(
                  StepsTravel.DatosAsegurados,
                  this.state.currentStep === StepsTravel.DatosAsegurados,
                  true
                )}
                {!this.props.disableSubButtons && (
                  <li>
                    {this.getMainButtonSubMenu(
                      "NUEVO ASEGURADO",
                      StepsTravel.DatosAsegurados,
                      () => this.tryInsuredOnAdd(),
                      "full-light",
                      images.PlusWhite,
                      this.isMenuItemDisabled(StepsTravel.DatosAsegurados) ||
                        this.state.insureds.length === 10
                    )}
                  </li>
                )}
              </ul>
            </li>
            <li>{this.getMainButtonMenu("PROTECCIÓN DE DATOS", StepsTravel.ProteccionDatos)}</li>
            <li>{this.getMainButtonMenu("MÉTODOS DE PAGO", StepsTravel.MetodosPago)}</li>
            <li>
              {this.getMainButtonMenu(
                "DETALLE PREV. CONTRATACIÓN",
                StepsTravel.DetallePrevioContratacion
              )}
              <ul className="ulSubmenu" style={{ display: true ? "block" : "none" }}>
                <li>
                  {this.state.currentStep === StepsTravel.DetallePrevioContratacion &&
                    this.getMainButtonSubMenu(
                      "DESCARGAR",
                      StepsTravel.DetallePrevioContratacion,
                      () => this.tryDownloadPrecontractualDocument(),
                      "full-light"
                    )}
                  {this.state.currentStep === StepsTravel.DetallePrevioContratacion &&
                    this.getMainButtonSubMenu(
                      "ENVIAR POR EMAIL",
                      StepsTravel.DetallePrevioContratacion,
                      () => this.tyrSendMailPrecontractualDocument(),
                      "full-light"
                    )}
                  {this.state.currentStep === StepsTravel.DetallePrevioContratacion &&
                    this.getMainButtonSubMenu(
                      "ENVIAR EL PAGO",
                      StepsTravel.DetallePrevioContratacion,
                      () => this.tryResumeOnHiring(),
                      "full-light",
                      undefined,
                      this.props.isHired
                    )}
                </li>
              </ul>
            </li>
          </div>
        </ul>
      </TravelHireMenuContainer>
    );
  }
}

export const TravelHireMenu = withPolicy(withRouter(TravelHireMenuLayout));
